var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 16.667L11.1748 15.492L6.52484 10.8337H16.6665V9.16699H6.52484L11.1748 4.50866L9.99984 3.33366L3.33317 10.0003L9.99984 16.667Z",
    fill: "#9B9B9B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 19.5,
    width: 19,
    height: 19,
    transform: "rotate(-180 19.5 19.5)",
    stroke: "#9B9B9B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_565"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-180 20 20)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.717e1826457a4c4ee685c2fed506ce6d.svg";
export { ForwardRef as ReactComponent };